function queryStringToObject(queryString: string): { [key: string]: string } {
  if (queryString.length === 0) {
    return {};
  }
  // Удаляем знак вопроса в начале строки, если он есть
  if (queryString.startsWith('?')) {
    queryString = queryString.slice(1);
  }

  // Разбиваем строку по символу '&' для получения пар ключ-значение
  const pairs = queryString.split('&');
  const result: { [key: string]: string } = {};

  pairs.forEach((pair) => {
    // Разбиваем каждую пару по символу '='
    const [key, value] = pair.split('=');
    // Преобразуем ключ и значение и сохраняем в объект
    result[decodeURIComponent(key)] = value ? decodeURIComponent(value) : '';
  });

  return result;
}

export default queryStringToObject;
